/**
 * Helpers compartidos por la tabla de roles y el modal de matriz.
 *
 * El catalogo (que modulos y acciones existen) viene de permissions_catalog.php,
 * asi que anadir una accion en PHP la hace aparecer en la UI sin tocar estos
 * archivos: nunca se enumeran modulos ni acciones aqui.
 */

export const label = (node) => node.label_es || node.code;

// Un modulo/accion esta concedido cuando el valor guardado es truthy. El API
// normaliza a 1/0, asi que cualquier otra cosa se trata como no concedido.
export const granted = (value) => value === 1 || value === true || value === '1';

// Hay acciones que el backend concede siempre a cualquier rol (hoy biblio.view, para
// que "Mi tienda" nunca quede sin su entrada al pricing). El API lo publica en cada
// accion como `always_granted` para que la UI no tenga que hardcodear la lista ni
// descubrirlo al guardar: el tag se pinta ya puesto y sin opcion de quitarlo, que es
// exactamente como lo va a devolver el servidor.
export const isForced = (action) => Boolean(action && action.always_granted);

// Las que el usuario si puede decidir. Alimentan el combo: solo queda por añadir lo
// que todavia no esta concedido.
export const optionalActions = (mod, modules) => {
    const from = (modules && modules[mod.code]) || {};
    return mod.actions.filter((a) => !isForced(a) && !granted(from[a.code]));
};

// Mismo criterio que perm_role_code_valid() en PHP. Se replica aqui para avisar
// antes de hacer un round trip, no para sustituir la validacion del servidor.
export const CODE_RE = /^[a-z][a-z0-9_]*$/;
export const CODE_MAX = 32;
export const NAME_MAX = 64;

// Todos los pares modulo/accion deben aparecer con 1/0 explicito para que el
// payload se describa solo y la comparacion de "sin guardar" sea fiable. El API
// tambien normaliza a 0 lo que falte, pero un borrador con una clave vieja
// compararia distinto sin que haya un cambio real que guardar.
export function normalise(modules, catalog) {
    const source = modules || {};
    const out = {};
    (catalog || []).forEach((m) => {
        const from = source[m.code] || {};
        const actions = {};
        m.actions.forEach((a) => {
            actions[a.code] = isForced(a) || granted(from[a.code]) ? 1 : 0;
        });
        out[m.code] = actions;
    });
    return out;
}

// Cuantas acciones quedan habilitadas. Usa el catalogo para no contar claves
// huerfanas que ya no existan en el servidor.
export function countOn(modules, catalog) {
    const source = modules || {};
    return (catalog || []).reduce(
        (n, m) => n + m.actions.filter((a) => granted(source[m.code] && source[m.code][a.code])).length,
        0
    );
}

// Cuantas eligio el usuario de verdad, sin contar las forzadas. Sirve para el aviso
// de "cambios sin guardar" de un alta nueva: con biblio.view siempre concedido, un
// modal recien abierto ya contaria permisos y pediria confirmar siempre.
export function countChosenOn(modules, catalog) {
    const source = modules || {};
    return (catalog || []).reduce(
        (n, m) => n
            + m.actions.filter((a) => !isForced(a) && granted(source[m.code] && source[m.code][a.code])).length,
        0
    );
}
